import React, { useLayoutEffect, useRef } from 'react'
import { IdCard, Wallet } from 'lucide-react'
import { usePrivanaI18n } from '@/i18n/PrivanaI18nProvider.jsx'

/** A presentation of a possible future card; no credential or issuance state. */
export default function MemberDigitalMembershipCard({ overview, branding, member }) {
  const { t } = usePrivanaI18n()
  const tr = key => t(`digitalMembershipCard.${key}`)
  const ref = useRef(null)
  useLayoutEffect(() => {
    const section = ref.current, main = section?.closest('main')
    const owner = section && getComputedStyle(section).overflowY === 'auto' ? section
      : main && getComputedStyle(main).overflowY === 'auto' ? main : document.scrollingElement
    if (owner) owner.scrollTop = 0
  }, [])
  const unavailable = t('membershipInformation.unavailable')
  const data = overview.data
  const name = member?.full_name || [member?.first_name || member?.firstName, member?.last_name || member?.lastName].filter(Boolean).join(' ') || unavailable
  const fields = [[tr('name'), name], [t('membershipInformation.number'), data?.membership_number || unavailable], [t('membershipInformation.type'), data?.membership?.type || unavailable]]
  return <section className="mp-digital-card-scroll" ref={ref} aria-label={tr('title')} aria-busy={overview.status === 'loading'}>
    {overview.status === 'loading' ? <p role="status">{t('profileOverview.loading')}</p> : overview.status === 'failed' ? <div role="alert"><p>{t('profileOverview.error')}</p><button type="button" className="mp-ghost" onClick={() => overview.refresh()}>{t('membershipInformation.retry')}</button></div> :
      <div className="mp-digital-showcase">
        <div className="mp-digital-intro"><span className="mp-digital-soon"><IdCard size={16} aria-hidden="true"/>{tr('soon')}</span><h4>{tr('heading')}</h4><p>{tr('intro')}</p></div>
        <div className="mp-graphite-card">
          <div className="mp-graphite-brand">{branding?.logoUrl ? <img src={branding.logoUrl} alt={branding.clubName || ''}/> : null}{branding?.clubName ? <span>{branding.clubName}</span> : null}</div>
          <div className="mp-graphite-member"><strong>{name}</strong><dl>{fields.slice(1).map(([label,value]) => <div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}</dl></div>
          <small className="mp-graphite-preview">{tr('design')}</small>
        </div>
        <dl className="mp-digital-details">{fields.map(([label,value]) => <div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}</dl>
        <div className="mp-digital-wallet"><Wallet size={21} aria-hidden="true"/><span>Apple Wallet</span><small>{tr('planned')}</small></div>
        <p className="mp-digital-disclaimer">{tr('disclaimer')}</p>
      </div>}
  </section>
}
